export default __webpack_public_path__ + "close.46070c0b3002ec74.svg";